import React, { useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { getUser, saveUser } from '../redux/userActions';
import { BackButton, Loader } from '../../../common/components';
import InternalContainer from '../../layout/containers/Internal';

import UserForm from '../components/UserForm/UserForm';
import getIncludedResource from '../../../helpers/getIncludedResource';

const UserEditContainer = ({ params, onGetUser, onSaveUser }) => {
  const { id } = params;

  useEffect(
    () => {
      if (id) {
        onGetUser(id);
      }
    },
    [onGetUser, id],
  );

  const user = useSelector((state) => state.user.resources?.[id]);

  if (!user) {
    return (
      <InternalContainer title="User" buttons={<BackButton />}>
        <Loader />
      </InternalContainer>
    );
  }
  const currentOrganisation = getIncludedResource(
    user.data,
    user.included,
    'current_organisation',
  );

  const isOwnerUser =
    currentOrganisation?.data?.attributes?.organisation_type_name === 'Owner';

  const save = (values) => {
    onSaveUser(values);
  };

  const userMetadata = user.data.attributes?.metadata ?? {};
  const formatMetadata =
    Array.isArray(userMetadata) && !userMetadata?.length ? {} : userMetadata;

  const resource = {
    data: {
      ...user.data,
      attributes: {
        ...user.data.attributes,
        metadata: {
          ...formatMetadata,
        },
      },
      relationships: {
        ...user.data.relationships,
      },
    },
  };

  const organisations = getIncludedResource(user.data, user.included, 'organisations');

  return (
    <InternalContainer title="User" buttons={<BackButton />}>
      <UserForm
        resource={resource}
        onSave={save}
        isOwnerUser={isOwnerUser}
        organisations={organisations}
      />
    </InternalContainer>
  );
};
export default connect(
  null,
  {
    onGetUser: getUser,
    onSaveUser: saveUser,
  },
)(UserEditContainer);
